export const text = {
  image: "https://phongtro123.com/images/contact-us-pana-orange.svg",
  content: "Hỗ trợ chủ nhà đăng tin",
  contact: [
    {
      text: "Nếu bạn cần hỗ trợ đăng tin, vui lòng liên hệ số điện thoại bên dưới:",
      phone: "ĐT: 0909316890",
      zalo: "Zalo: 0909316890",
    },
    {
      text: "Hỗ trợ ngoài giờ",
      zalo: "Zalo: Phongtro123",
    },
  ],
};
